<template>
    <v-dialog
        v-model="isActive"
        attach="#app"
        overlay-color="#000"
        :overlay-opacity="0.8"
        width="400"
        @click:outside.prevent="closeHandle"
    >
        <div v-if="isActive" class="client-delete__body">
            <h3 class="client-delete__title">
                {{ $t('pages.payments.saveWithRivhitPaymentSystem') }}
            </h3>

            <v-divider></v-divider>

            <div class="client-delete__actions">
                <v-btn
                    min-width="85"
                    class="client-delete__btn"
                    small
                    color="#3bafda"
                    :disabled="isSubmitting"
                    :dark="!isSubmitting"
                    @click="handlePayment(true)"
                >
                    {{ $t('pages.payments.saveWithRivhit') }}
                </v-btn>
                <v-btn
                    min-width="85"
                    class="client-delete__btn"
                    small
                    color="#967adc"
                    :disabled="isSubmitting"
                    :dark="!isSubmitting"
                    @click="handlePayment(false)"
                    >{{ $t('pages.payments.saveOnlyLocally') }}
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import modalsMixin from '@/mixins/modals.mixin'
import languageMixin from '@/mixins/language.mixin'
import popUpTypes from '@/types/pop-up-types'
import { mapActions } from 'vuex'
import { paymentsV2ActionTypes } from '@/store/modules/payments_v2/types'
import { actionTypes as actionTypesModalNotifications } from '@/store/modules/modal-notifications'
const { confirmPayment } = popUpTypes

export default {
    name: 'OrderConfirmPayment',
    mixins: [modalsMixin, languageMixin],
    data() {
        return {
            selfName: confirmPayment,
            isSubmitting: false,
        }
    },
    computed: {
        wigID() {
            return this.$route.params.wigID
        },
    },
    watch: {
        isActive(newValue) {
            if (newValue) {
                this.isSubmitting = false
            }
        },
    },
    methods: {
        ...mapActions('paymentsV2', {
            confirmPayment: paymentsV2ActionTypes.CONFIRM_PAYMENTS,
        }),
        ...mapActions('modalNotifications', {
            success: actionTypesModalNotifications.success,
            error: actionTypesModalNotifications.error,
        }),
        handlePayment: async function (withRivhit) {
            try {
                this.isSubmitting = true

                const res = await this.confirmPayment({
                    wigId: this.wigID,
                    withRivhit,
                })

                if (!res.data) {
                    await this.success(
                        this.$t('pages.payments.paymentSavedLocally')
                    )

                    this.goBack()

                    return
                }

                await this.success(
                    this.$t('pages.payments.paymentSavedWithRivhit')
                )

                const documentUrl = res.data

                window.open(documentUrl, '_blank')

                this.goBack()
            } catch (e) {
                console.error('Error sending payment data:', e)
                await this.error(this.$t('pages.payments.errorSavingPayment'))
            } finally {
                this.isSubmitting = false
                this.closeHandle()
            }
        },
        goBack: function () {
            const tabHasHistory = window.history.length > 1

            if (tabHasHistory) {
                return this.$router.back()
            }

            return this.$router.push('/orders')
        },
    },
}
</script>

<style lang="scss">
.client-delete {
    &__title {
        text-align: center;
        margin-bottom: 15px;
    }

    &__body {
        height: fit-content;
        background: $color-primary-light;
        padding: 30px 15px 0;
    }

    &__actions {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
    }

    &__btn {
        min-width: 85px;
    }
}
</style>
